import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import AuthProvider from "./contexts/AuthContext";
import "./index.css";
import App from "./App";
import SignupInfoProvider from "./contexts/SignupInfoContext";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <SignupInfoProvider>
          <App />
        </SignupInfoProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
